import { JsonObject, JsonProperty } from "ta-json";

import Link from "../../link";

@JsonObject()
export class MemberPolicyResource {
    @JsonProperty("definition")
    definition: Link;

    @JsonProperty("target")
    target: string;

    @JsonProperty("can_read")
    canRead: boolean;

    @JsonProperty("can_write")
    canWrite: boolean;

    constructor(init?: Partial<MemberPolicyResource>) {
        Object.assign(this, init);
    }
}
